module.exports = __webpack_public_path__ + "static/media/header.531ee4ba.svg";